import { About } from '../../pages/about/About';
import { Blog } from '../../pages/blog/Blog';
import { Events } from '../../pages/events/Events';
import { Home } from '../../pages/home/Home';
import { Order } from '../../pages/order/Order';
import { Orders } from '../../pages/order/Orders';
import { Partnerships } from '../../pages/partnerships/Partnerships';
import { Gallery } from '../../pages/gallery/Gallery';
// import { NextGenRegistration } from '../../pages/NextGen2025/NextGenRegister';
import { PdoRegister } from '../../pages/pdo-register/PdoRegister';
import { PdoFeedback } from '../../pages/pdo-feedback/PdoFeedback';
import { FormClosed } from '../components/FormClosed';
// import { HaluRegister } from '../../pages/halu/HaluRegister';
import { HaluFeedback } from '../../pages/halu-feedback/HaluFeedback';
// import { IndependenceDayRegistration } from '../../pages/independence/Independence';
import { Page } from '../types/types';
import { WaroengPage } from '../../pages/waroeng/WaroengPage';
//import { Nextgen } from '../../pages/nextgen/Nextgen';
// import { PaRemboRegistration } from '../../pages/pa-rembo/PaRemboRegister';
// import { FunrunRegistration } from '../../pages/funrun/FunrunRegister';

const PAGES: Page[] = [
  { name: 'home', path: '', element: <Home /> },
  { name: 'about', path: 'about', element: <About />, navbar: true },
  { name: 'events', path: 'events', element: <Events />, navbar: true },
  { name: 'blog', path: 'blog', element: <Blog />},
  { name: 'sponsorship', path: 'sponsorship', element: <Partnerships />, navbar: true },
  { name: 'merchandise', path: 'order', element: <Order /> ,navbar: true },
  { name: 'gallery', path: 'gallery', element: <Gallery /> },
  {
    name: 'orders',
    path: 'secretpathonlyforexecsmerchandiseorders',
    element: <Orders />,
  },
  { name: 'waroeng', path: 'waroeng', element: <WaroengPage />, navbar: true },
  // { name: 'pa-rembo', path: 'pa-rembo', element: <PaRemboRegistration /> },
  { name: 'pa-rembo', path: 'pa-rembo', element: <FormClosed/> },
  //{ name: 'PERMIKA NextGen', path: 'nextgen', element: <Nextgen /> },
  { name: 'PDO Registration', path: 'pdo/register', element: <PdoRegister /> },
  // { name: 'PDO Registration', path: 'pdo/register', element: <FormClosed /> },
  { name: 'PDO Feedback', path: 'pdo/feedback', element: <PdoFeedback /> },
  // { name: 'Halu Registration', path: 'halu/register', element: <HaluRegister /> },
  { name: 'Halu Registration', path: 'halu/register', element: <FormClosed /> },
  { name: 'HALU Feedback', path: 'halu/feedback', element: <HaluFeedback /> },
  // { name: 'Independence Day Registration', path: 'independence-day/register', element: <IndependenceDayRegistration /> }
  { name: 'Independence Day Registration', path: 'independence-day/register', element: <FormClosed /> },
  // { name: 'NextGen Registration', path: 'nextgen/register', element: <NextGenRegistration /> },
  { name: 'NextGen Registration', path: 'nextgen/register', element: <FormClosed /> },
  // { name: 'Fun Run Registration', path: 'funrun/register', element: <FunrunRegistration /> }
  { name: 'Fun Run Registration', path: 'funrun/register', element: <FormClosed /> }
];

export { PAGES };
